import { ScoreResponse } from '../adapters/api-client/subscription/Subscription.model';

export interface ScoreProps {
  score: ScoreResponse | undefined;
}

export enum ResponsePageType {
  NONE = 'NONE',
  IMMO = 'IMMO',
  CONSO = 'CONSO',
}

export interface ResponseModel {
  name: string;
  navLabel: string;
  title: string;
  tipsTitle: string;
  tipsBody: string;
  subTitle: string;
  details: string;
  importantDetails: string;
}

export const signatureByName = (name: ResponsePageType): ResponseModel | undefined => {
  return responsePages.find((response) => response.name === name);
};

export const responsePages: ResponseModel[] = [
  {
    name: ResponsePageType.IMMO,
    navLabel: 'Reponse',
    title: `Votre demande \n est en cours d’étude`,
    tipsTitle: '',
    tipsBody: '',
    subTitle: "Merci d'avoir rempli le formulaire.\n Nous vous contacterons dans les plus brefs délais.",
    details: 'La mensualité proposée pourra être optimisée avec votre conseiller.',
    importantDetails: '',
  },
  {
    name: ResponsePageType.CONSO,
    navLabel: 'Reponse',
    title: `Votre demande \n est en cours d’étude`,
    tipsTitle: '',
    tipsBody: '',
    subTitle: "Merci d'avoir rempli le formulaire. \nNous vous contacterons dans les plus brefs délais.",
    details: 'La mensualité proposée pourra être optimisée avec votre conseiller.',
    importantDetails: '',
  },
  {
    name: ResponsePageType.NONE,
    navLabel: 'Reponse',
    title: `Votre demande \n est en cours d’étude`,
    tipsTitle: '',
    tipsBody: '',
    subTitle: "Merci d'avoir rempli le formulaire. \nNous vous contacterons dans les plus brefs délais.",
    details: 'Les informations que vous nous avez transmises ne nous permettent pas de vous donner un avis immédiat.',
    importantDetails: '',
  },
];
